// app/localization/overrides.js
// Здесь можно переопределить любые переводы модулей для конкретного проекта

export default {
  // Переопределяем переводы auth модуля для Commune
  auth: {
    en: {
      auth: {
        signIn: {
          // title — имя страницы (вкладка браузера), greeting — приветствие на
          // самом экране: в martyrs 0890c10 это два ключа. Без greeting на экране
          // стоял текст martyrs «Welcome to OZ DAO,».
          title: "Sign In",
          greeting: "Welcome to Commune,",
          subtitle: "Sign In to Continue",
          signup: "Don't have an account?",
          phone: "Phone",
          email: "Email",
          phonePlaceholder: "Enter your phone",
          emailPlaceholder: "Enter your email",
          haveAccount: "Don't have an account? Sign Up",
          passwordPlaceholder: "Enter your password",
          forgotPassword: "Forgot Password?",
          signin: "Sign In",
          signin_apple: "Sign In with Apple",
          soon: "SOON"
        },
        // features на уровне auth (не внутри signIn) — так в martyrs
        features: [
          {
            title: "Beachfront Paradise in Phuket",
            description: "Experience Commune – where quality dining meets ocean views on Karon Beach."
          },
          {
            title: "Day to Night Destination",
            description: "From sunrise coffee to midnight cocktails, enjoy every moment in our unique beachfront space."
          },
          {
            title: "Exclusive Member Benefits",
            description: "Book tables, access special events, and manage your reservations through our platform."
          },
          {
            title: "Your Beachfront Escape",
            description: "Enjoy premium cocktails and cuisine with stunning ocean views at Karon Beach."
          }
        ],
        signUp: {
          title: "Sign Up",
          description: "Choose a convenient way to register via phone or email:",
          phone: "Phone",
          email: "Email",
          phonePlaceholder: "Enter your phone",
          emailPlaceholder: "Enter your email",
          emailNotice: "We will send you an email with a confirmation code that you will need to enter in the next step.",
          smsNotice: "We will send you an SMS with a confirmation code that you will need to enter in the next step.",
          sendCode: "Send Code",
          haveAccount: "Already have an account?"
        },
        enterCode: {
          verifyNumberTitle: "Verify Number",
          instructions: "We have sent a registration code to your phone number. Please enter it in the field below:",
          resendCode: "Send the code again",
          secondsResend: "seconds to the possibility of sending the code again."
        },
        resetPassword: {
          forgotPasswordTitle: "Forgot Password?",
          instructions: "To reset your password, specify the phone or email used during registration.",
          smsInfo: "We will send you an SMS with a confirmation code to reset your password, which you will need to enter in the next step.",
          emailInfo: "We will send you an email with a confirmation code to reset your password, which you will need to enter in the next step.",
          phone: "Phone",
          email: "Email",
          phonePlaceholder: "Enter your phone",
          emailPlaceholder: "Enter your email",
          sendCode: "Send code"
        },
        enterPassword: {
          almostDone: "Almost there!",
          newPasswordPrompt: "Please, set a new password.",
          registrationPasswordPrompt: "Please, set your password to complete the registration.",
          passwordPlaceholder: "Password",
          repeatPasswordPlaceholder: "Repeat Password",
          changePasswordBtn: "Change Password",
          registerBtn: "Register"
        }
      }
    }
  }
};